export const JSS_SSR_STYLES_ID = 'jss-server-side'

export const COOKIE_WEBP_SUPPORTED = 'LK_webp_supported'
export const COOKIE_TRUE = 't'
export const COOKIE_FALSE = 'f'
